import { capitalizeFirstLetter } from 'src/utils/string';
import TextMenuItems from './text-menu-items';

export class TableMenuItems {
  /**
  * @function constructor
  */
  constructor ($tableElement, buttonSelect, popupMenuCommonFunctions, defaultMenus) {
    this.editor = INKIVE.Tool.getInstance().editor;
    this.canvas = INKIVE.Tool.getInstance().editor.canvas;

    const $selectedTextElements = $tableElement.find('.table-cell-selected').parent();

    this.$tableElement = $tableElement;
    this.$textElement = $selectedTextElements?.length
      ? $selectedTextElements
      : $tableElement.find('g.textarea');
    this.tableElement = $tableElement[0];

    this.buttonSelect = buttonSelect;
    this.popupMenuCommonFunctions = popupMenuCommonFunctions;
    this.defaultMenus = defaultMenus;
    this.hasLibrary = popupMenuCommonFunctions.hasLibrary;
    this.textMenuItems = new TextMenuItems(this.$textElement, buttonSelect, popupMenuCommonFunctions, defaultMenus);
  }

  drawTableMenuItems () {
    const isTableEdit = this.canvas.getMode() === 'table-edit';

    this.$tableElement.popupmenu({ buttons: this.defaultMenus[(isTableEdit ? 'TABLE_EDIT' : 'TABLE')] });

    this.textMenuItems.drawTextBlockActions();
    this.updateToolBarButtons();
  }

  updateToolBarButtons () {
    const buttons = ['bold', 'italic', 'underline', 'bullets', 'list', 'case'];
    for (const button of buttons) {
      this.buttonSelect(`on_cell-${button}`).toggleClass(
        'applied',
        this[`_has${capitalizeFirstLetter(button)}Text`]()
      );
    }
  }

  _hasBoldText () {
    const boldVariations = ['bold', 'bolder', '700', '800', '900'];
    const selector = boldVariations.map(variation => `[font-weight="${variation}"]`).join(',');

    return !!this.tableElement?.querySelector(selector);
  }

  _hasItalicText () {
    return !!this.tableElement?.querySelector('[font-style="italic"]');
  }

  _hasUnderlineText () {
    return !!this.tableElement?.querySelector('[text-decoration="underline"]');
  }

  _hasBulletsText () {
    return !!this.tableElement?.querySelector('.bullets');
  }

  _hasListText () {
    return !!this.tableElement?.querySelector('.ordered');
  }

  _hasCaseText () {
    const content = this.tableElement?.textContent;

    if (!content) return false;

    return content !== content.toLowerCase();
  }

  toggleAppliedClass (selector, applied) {
    this.buttonSelect(selector).toggleClass('applied', applied);
  }
}
